import { Amplify } from 'aws-amplify';
import config from '../config';

// Configure Amplify
Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: config.userPoolId,
      userPoolClientId: config.userPoolClientId,
      identityPoolId: config.identityPoolId,
      loginWith: {
        email: true,
      },
      // Disable signup - only allow admin-created users
      signUpVerificationMethod: 'code',
      userAttributes: {
        email: {
          required: true,
        },
        name: {
          required: true,
        },
      },
      allowGuestAccess: false,
      passwordFormat: {
        minLength: 12,
        requireLowercase: true,
        requireUppercase: true,
        requireNumbers: true,
        requireSpecialCharacters: true,
      },
    }
  },
  API: {
    REST: {
      UserManagementAPI: {
        endpoint: config.apiBaseUrl,
        region: config.region,
      }
    }
  }
});

export default Amplify;